define([
    "./trackingModule",
    "lodash",
    "json!../tdn/tdnByEntity.json"
], function (trackingModule, _, tdnByEntity) {
    "use strict";

    trackingModule.controller("TrackingController", [
        "$scope",
        "routeService",
        "loadingService",
        "remoteExceptionHandler",
        "truckMarkerPopupCreator",
        "trackingService",
        "$q",
        "trackingMonitorableList",
        "messagesModal",
        "$timeout",
        "monitoringService",
        "tdnHelp",
        function ($scope, routeService, loadingService, remoteExceptionHandler, truckMarkerPopupCreator, trackingService, $q, trackingMonitorableList, messagesModal, $timeout, monitoringService, tdnHelp) {
            $scope.tdn = tdnByEntity?.[tdnHelp.getContext()]?.["tracking"]

            $scope.serviceName = monitoringService.getMonitorableSearchUrl();

            $scope.here = {
                markers: []
            }

            $scope.show = {orphanSignals: true};

            $scope.search = function (modifiedTemplate) {
                $scope.moritoringTripIdMap = {};
                $scope.template = modifiedTemplate;
                retrieveTripsAndCreateMarkers(modifiedTemplate, true);
            };
            function retrieveTripsAndCreateMarkers(modifiedTemplate, centerOnTruck) {
                clearMap();
                var promises = [];
                promises.push(monitoringService.filterMonitorableTrackingSummary(modifiedTemplate));
                if ($scope.show.orphanSignals) {
                    promises.push(trackingService.getLatestOrphanSignals());
                }

                loadingService($q.all(promises)).then(function (filterResult) {
                    var monitorableTrackingSummary = filterResult[0].result;
                    monitorableTrackingSummary.map(function (monitorable) {
                        return createMarkers(monitorable);
                    });

                    if (filterResult[1]) {
                        var latestOrphanSignals = filterResult[1];
                        latestOrphanSignals.map(function (signal) {
                            return createMarkersFromSignals(signal);
                        });
                    }
                }).catch(remoteExceptionHandler());
            }

            function createMarkersFromSignals(signal) {
                let popupContent = {
                    markerId: signal.deviceId + signal.providerId, //para evitar clash com o id dos monitoráveis
                    providerId: signal.providerId,
                    deviceId: signal.deviceId,
                    lastPosition: signal,
                    truckIcon: signal.old ? 'LATE' : '',
                    isOrphanSignal: true
                };
                let item = truckMarkerPopupCreator(popupContent);
                setMarkers(item);
            }

            function createMarkers(summary) {
                var destination = null;
                var nextTransition = summary.nextTransition;
                if (nextTransition && nextTransition.location && nextTransition.location.locality) {
                    var locality = nextTransition.location.locality;
                    destination = [locality.street, locality.number, locality.district, locality.city].filter(function (value) {
                        return !!value;
                    }).join(", ");
                }

                let popupContent = {
                    markerId: summary.id,
                    monitorableCode: summary.sourceId,
                    type: summary.type,
                    vehicle: summary.vehicle ? summary.vehicle.name : "",
                    driver: summary.currentDriver,
                    currentPlate: summary.currentPlate,
                    lastPosition: summary.lastPosition,
                    lastTransition: summary.lastTransition,
                    destination: destination,
                    nextTransition: nextTransition,
                    nextTransitionTime: nextTransition ? nextTransition.expectedTimestamp : null,
                    children: summary.children,
                    hasPendingOccurrences: summary.hasPendingOccurrences,
                    truckIcon: summary.positionStatusIcon,
                    isOrphanSignal: false,
                    deviceId: summary.deviceId
                };

                let item = truckMarkerPopupCreator(popupContent);
                setMarkers(item);
            }

            function setMarkers(item) {
                $scope.here.markers.push(
                    {
                        geographicInfo: {
                            latitude: item.coords.latitude,
                            longitude: item.coords.longitude
                        },
                        data: {
                            id: item.identifier,
                            icon: item.icon,
                            popupConfig: item.popupConfig
                        }
                    }
                );
            }

            function clearMap() {
                $scope.here.markers = [];
            }

            $scope.refresh = function () {
                if ($scope.template) {
                    retrieveTripsAndCreateMarkers($scope.template);
                }
            };

            let markersHereApi = null;
            $scope.onRegisterHereApi = function (api) {
                markersHereApi = api;
            };

            $scope.inspect = function (result) {
                let tripEnum = "br.com.neolog.monitoring.monitorable.model.api.StandardMonitorableType.TRIP";
                let monitorable = {
                    id: result.id,
                    sourceId: result.trip,
                    type: result.type  === tripEnum ? "Trip" : ""
                };

                let listMonitorables = [monitorable];
                result.children.forEach(function (children) {
                    let c = {
                        id: children.id,
                        sourceId: children.sourceId,
                        type: children.typeName
                    };
                    listMonitorables.push(c);
                });

                trackingMonitorableList(listMonitorables);
            };
        }]);
});